<div class="message-typing-indicator">
  <span></span>
  <span></span>
  <span></span>
</div>
